import { render, staticRenderFns } from "./RotinasComercial.vue?vue&type=template&id=66aab894&scoped=true&"
import script from "./RotinasComercial.vue?vue&type=script&lang=js&"
export * from "./RotinasComercial.vue?vue&type=script&lang=js&"
import style0 from "./RotinasComercial.vue?vue&type=style&index=0&lang=css&"
import style1 from "./RotinasComercial.vue?vue&type=style&index=1&id=66aab894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aab894",
  null
  
)

export default component.exports